import { useEffect, useState } from "react";
import parse from 'html-react-parser';

type UseReplaceCMS = {
    data?: string
    loading?: boolean
    replace?: (domNode: any) => any
}

export const useReplaceCMS = ({ data = '', loading = false, replace }: UseReplaceCMS) => {
    if (typeof data !== 'string') return { content: '', tableContent: [] };
    const [tableContent, setTableContent] = useState<any[]>([]);

    useEffect(() => {
        if (loading) {
            setTableContent(Array(5).fill({
                title: '',
                content: Array(3).fill('')
            }));
            return;
        }

        if (typeof window === 'undefined') return;
        const textConvert = parseHTMLtoPrivacyArray(data);
        setTableContent(textConvert);
    }, [data, loading])

    const options = {
        replace: replace
    };

    const content = parse(data, options);

    return {
        content,
        tableContent
    }
}

const parseHTMLtoPrivacyArray = (htmlString: string) => {
    const parser = new DOMParser();
    const html = removeFirstH2(htmlString).html;
    const doc = parser.parseFromString(html, 'text/html');
    const result = [] as any[];

    const titles = doc.querySelectorAll('h3');

    titles.forEach((titleElement: any) => {
        const title = titleElement.textContent.trim();
        result.push({ title });
    });

    return result;
}

const removeFirstH2 = (htmlString: string) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlString, 'text/html');

    const firstH2 = doc.querySelector('h2');
    let h2Content = '';

    if (firstH2) {
        h2Content = firstH2.textContent || '';

        firstH2.remove();
    }

    return {
        h2: h2Content,
        html: doc.body.innerHTML
    };
}